/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-09-28
 * @brief EHP 사용자 메일 인증 실패 개발
 *
 ********************************************************************/
import React, { useEffect } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, } from "recoil";
import { getApiLangState } from "../../../recoil/langState";
// utils
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CONST from "../../../utils/Const";
/**
 * @brief EHP 이메일 인증 실패 컴포넌트
 * @param -
 * @returns react components
 */
function NoEhpCertification() {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const userId = localStorage.getItem(CONST.STR_EMAIL);
    const { data: data, run } = useAsync({
        //promiseFn: HttpUtil.getUsers,
        deferFn: HttpUtil.Http,
        httpMethod: "POST",
        appPath: "/api/v2/auth/key",
        appQuery: {
            userId: userId,
            language: apiLang,
            // (langs ==='')?Korean
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                alert("메일 전송을 완료 하였습니다.");
            }
            else {
                alert(data.errorList.map((err) => err.msg));
            }
        }
    }, [data]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "login__right webmailok" },
            React.createElement("h2", null,
                React.createElement("p", { className: "tit" }, "\uC778\uC99D \uC2E4\uD328")),
            React.createElement("div", { className: "login__form" },
                React.createElement("form", { action: "#", method: "", name: "loginform" },
                    React.createElement("fieldset", null,
                        React.createElement("p", { className: "login__info" }, "\uBA54\uC77C \uC778\uC99D\uC774 \uC2E4\uD328 \uB418\uC5C8\uC2B5\uB2C8\uB2E4."),
                        React.createElement("button", { type: "button", className: "btn-login js-open", "data-pop": "join-ok", onClick: run },
                            React.createElement("span", null, "\uC778\uC99D\uBA54\uC77C \uC7AC\uBC1C\uC1A1")))))),
        React.createElement(JoinDone, null)));
}
export default NoEhpCertification;
function JoinDone(props) {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const userId = localStorage.getItem(CONST.STR_EMAIL);
    const { data: data, run } = useAsync({
        //promiseFn: HttpUtil.getUsers,
        deferFn: HttpUtil.Http,
        httpMethod: "POST",
        appPath: "/api/v2/auth/key",
        appQuery: {
            userId: userId,
            language: apiLang,
            // (langs ==='')?Korean
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                alert("메일 전송을 완료 하였습니다.");
            }
        }
    }, [data]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "join-ok", className: "popup-layer js-layer layer-out hidden w560 login__popup" },
            React.createElement("div", { className: "popup__head" },
                React.createElement("h1", null, "\uD68C\uC6D0\uAC00\uC785"),
                React.createElement("button", { className: "btn btn-close js-close" },
                    React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
            React.createElement("div", { className: "popup__body joinok-h webmail" },
                React.createElement("div", { className: "complete-txt" },
                    React.createElement("p", { className: "joinok" },
                        "\uD68C\uC6D0\uAC00\uC785\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
                        React.createElement("br", null),
                        "\u2018",
                        localStorage.getItem(CONST.STR_EMAIL),
                        "\u2019 \uBA54\uC77C \uC8FC\uC18C\uB85C \uC778\uC99D \uBA54\uC77C\uC774 \uC804\uC1A1 \uB418\uC5C8\uC73C\uB2C8,",
                        React.createElement("br", null),
                        "\uC778\uC99D \uD6C4 \uACC4\uC18D \uC9C4\uD589\uD574 \uC8FC\uC138\uC694."),
                    React.createElement("button", { id: "certification", type: "button", onClick: run },
                        React.createElement("span", null, "\uC778\uC99D\uBA54\uC77C \uC7AC\uBC1C\uC1A1")),
                    React.createElement("div", { className: "joininfo" },
                        React.createElement("p", { className: "tit" }, "\uC778\uC99D \uBA54\uC77C\uC774 \uB3C4\uCC29\uD558\uC9C0 \uC54A\uC73C\uC168\uB098\uC694?"),
                        React.createElement("p", { className: "txt" }, "\uC2A4\uD338\uBA54\uC77C\uD568\uC744 \uD655\uC778\uD558\uAC70\uB098, \uC7A0\uC2DC\uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.")))))));
}
